module.exports = __webpack_public_path__ + "static/media/eclipse-parcial.ced29455.jpeg";